<template>
  <v-col
    class="d-flex px-2 px-md-3 py-2"
    cols="12"
    md="4"
  >
    <v-card
      class="flex-grow-1 border-base"
      rounded="lg"
      variant="outlined"
      color="ui-kit-bg-gray-60"
    >
      <v-card-title
        class="text-wrap text-ui-kit-text pt-4 px-4 pb-3 text-subtitle-1
      text-md-landing-h6 pt-md-6 px-md-6 pb-md-4"
      >
        {{ title }}
      </v-card-title>
      <div
        class="px-4 pb-6 px-md-6 pb-md-8"
        :class="{ 'd-flex': flex }"
      >
        <slot>
          <template v-if="data">
            <div
              v-if="phones?.length"
              class="d-none d-md-flex flex-column flex-md-row align-start align-md-center mb-2"
            >
              <p
                v-for="(phone, index) in phones"
                :key="index"
                :class="['text-ui-kit-text text-body-1 mb-0', { 'ml-4': index !== 0 }]"
              >
                {{ phone.text }}
              </p>
            </div>
            <div
              v-if="phones?.length"
              class="d-md-none d-flex flex-column flex-md-row align-start align-md-center mb-2"
            >
              <NuxtLink
                v-for="(phone, index) in phones"
                :key="index"
                :to="`tel:${phone.raw}`"
                :class="['text-body-1 hover-underline text-primary', { 'mt-2': index !== 0 }]"
              >
                {{ phone.text }}
              </NuxtLink>
            </div>
            <NuxtLink
              class="text-body-1 text-primary hover-underline"
              :to="`mailto:${email}`"
            >
              {{ email }}
            </NuxtLink>
          </template>
        </slot>
      </div>
    </v-card>
  </v-col>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { ContactsGroup } from '~/features/contacts/types'

const props = defineProps({
  title: { type: String, required: true },
  flex: { type: Boolean, default: false },
  data: { type: Object as PropType<ContactsGroup | null>, default: null },
})

const locale = useAppLocale()

const email = computed(() => locale.isCis && props.data?.emailCis ? props.data.emailCis : props.data?.email)
const phones = computed(() => locale.isCis && props.data?.phonesCis ? props.data.phonesCis : props.data?.phones)
</script>
